import { Peek } from '@cw-ui/peek';
import { useSelector, useDispatch } from 'react-redux';
import {
    setIsBulkImportOpen,
    setIsTemplateDownloadSuccess,
    setIsTemplateDownloadFailed,
    setIsFetchUsersFailed,
    bulkImportUsersSliceId,
    setIsUpdateUserFailed,
    setIsUploadFileFailed,
    setRemoveFileSuccessAlert,
    setRemoveFileFailedAlert,
    setRemoveUserSuccessAlert,
    setRemoveUserFailedAlert,
    resetState,
} from './slice';
import UploadHeader from './components/UploadHeader/UploadHeader';
import BulkUserImportGrid from './components/BulkUserImportGrid/BulkUserImportGrid';
import useResizeObserver from 'use-resize-observer';
import DownloadSuccessAlert from './components/Alerts/TemplateDownloadSuccess';
import DownloadFailureAlert from './components/Alerts/TemplateDownloadFailure';
import FailedToUpdateUserAlert from './components/Alerts/FailedToUpdateUser';
import FailedToFetchUsersAlert from './components/Alerts/FailedToFetchUsers';
import UploadDialog from './components/UploadDialog/UploadDialog';
import FailedToUploadFileAlert from './components/Alerts/FailedToUploadFile';
import { Card } from '@cw-ui/surface-components';
import FailedToRemoveUsers from './components/Alerts/FailedToRemoveUsers';
import RemoveFileSuccessful from './components/Alerts/RemoveFileSuccessful';
import RemoveFileDialog from './components/RemoveFileDialog/RemoveFileDialog';
import RemoveUserSuccessful from './components/Alerts/RemoveUserSuccessful';
import FailedToRemoveUser from './components/Alerts/FailedToRemoveUser';
import RemoveUserDialog from './components/RemoveUserDialog/RemoveUserDialog';

const BulkUserImport = () => {
    const dispatch = useDispatch();
    const isTemplateDownloadFailed = useSelector(state => state[bulkImportUsersSliceId]?.isTemplateDownloadFailed);
    const isTemplateDownloadSuccess = useSelector(state => state[bulkImportUsersSliceId]?.isTemplateDownloadSuccess);
    const isUploadDialogOpen = useSelector(state => state[bulkImportUsersSliceId]?.isUploadDialogOpen);
    const isFetchUsersFailed = useSelector(state => state[bulkImportUsersSliceId]?.isFetchUsersFailed);
    const isUserUpdateFailed = useSelector(state => state[bulkImportUsersSliceId]?.isUserUpdateFailed);
    const isUploadFileFailed = useSelector(state => state[bulkImportUsersSliceId]?.isFileUploadFailed);
    const isRemoveFileDialogOpen = useSelector(state => state[bulkImportUsersSliceId]?.isRemoveFileDialogOpen);
    const isRemoveFileFailed = useSelector(state => state[bulkImportUsersSliceId]?.isRemoveFileFailed);
    const isRemoveFileSuccess = useSelector(state => state[bulkImportUsersSliceId]?.isRemoveFileSuccess);
    const isRemoveUserDialogOpen = useSelector(state => state[bulkImportUsersSliceId]?.isRemoveUserDialogOpen);
    const isRemoveUserFailed = useSelector(state => state[bulkImportUsersSliceId]?.isRemoveUserFailed);
    const isRemoveUserSuccess = useSelector(state => state[bulkImportUsersSliceId]?.isRemoveUserSuccess);
    const { ref: headerRef, height: componentHeaderHeight } = useResizeObserver();

    const handleBulkImportOpen = () => {
        dispatch(setIsBulkImportOpen());
        dispatch(resetState());
    };
    const handleTemplateDownloadSuccess = () => {
        dispatch(setIsTemplateDownloadSuccess());
    };
    const handleTemplateDownloadFailed = () => {
        dispatch(setIsTemplateDownloadFailed());
    };
    const handleUpdateUserFailed = () => {
        dispatch(setIsUpdateUserFailed());
    };
    const handleUsersFailed = () => {
        dispatch(setIsFetchUsersFailed());
    };
    const handleUploadFileFailed = () => {
        dispatch(setIsUploadFileFailed());
    };
    const handleRemoveFileFailed = () => {
        dispatch(setRemoveFileFailedAlert());
    };
    const handleRemoveFileSuccess = () => {
        dispatch(setRemoveFileSuccessAlert());
    };
    const handleRemoveUserFailed = () => {
        dispatch(setRemoveUserFailedAlert());
    };
    const handleRemoveUserSuccess = () => {
        dispatch(setRemoveUserSuccessAlert());
    };

    return (
        <Peek
            defaultView={1}
            open
            onBackButton={handleBulkImportOpen}
            onClose={handleBulkImportOpen}
            text={{
                fullPage: 'Full Page',
                bottomPeek: 'Bottom Peek',
            }}
            hideOptions={{ centralPeek: true, sidePeek: true, bottomPeek: false, fullPage: false }}>
            {isTemplateDownloadSuccess && (
                <DownloadSuccessAlert handleTemplateDownloadSuccess={handleTemplateDownloadSuccess} />
            )}
            {isTemplateDownloadFailed && (
                <DownloadFailureAlert handleTemplateDownloadFailed={handleTemplateDownloadFailed} />
            )}
            {isFetchUsersFailed && <FailedToFetchUsersAlert handleFetchUsersFailed={handleUsersFailed} />}
            {isUserUpdateFailed && <FailedToUpdateUserAlert handleUpdateUserFailed={handleUpdateUserFailed} />}
            {isUploadFileFailed && <FailedToUploadFileAlert handleUploadFileFailed={handleUploadFileFailed} />}
            {isRemoveFileFailed && <FailedToRemoveUsers handleRemoveFileFailed={handleRemoveFileFailed} />}
            {isRemoveFileSuccess && <RemoveFileSuccessful handleRemoveFileSuccess={handleRemoveFileSuccess} />}
            {isRemoveUserFailed && <FailedToRemoveUser handleRemoveUserFailed={handleRemoveUserFailed} />}
            {isRemoveUserSuccess && <RemoveUserSuccessful handleRemoveUserSuccess={handleRemoveUserSuccess} />}
            {isUploadDialogOpen && <UploadDialog />}
            {isRemoveFileDialogOpen && <RemoveFileDialog />}
            {isRemoveUserDialogOpen && <RemoveUserDialog />}
            <div ref={headerRef} className="bulk_users_import__header">
                <Peek.Header>
                    <Peek.Title title="Import Users" />
                </Peek.Header>
                <UploadHeader />
            </div>
            <Card variant="default" sx={{ height: `calc(100% - ${componentHeaderHeight}px)`, margin: 2, padding: 2 }}>
                <BulkUserImportGrid />
            </Card>
        </Peek>
    );
};

export default BulkUserImport;
